// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"vi","itemsContainer":"wi"};